import React, { Component } from 'react';
export default class DeptMembers extends Component{
    
    render() {
        console.log("group_members",this.props.group_members)
        return (
                <div class="tab-system-details second-tab-system-details addtab-system-details">
                {Object.values(this.props.group_members) .length > 0? 
                this.props.group_members['primary_member'] && this.props.group_members['primary_member'].length > 0 ?
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt20">
                    <div class="all-box">
                        <div class="tab-title mb20">{this.props.group_type ==1 ? "Primary Members":"Members"}</div>
                        <div class="row">
                            {this.props.group_members.primary_member.map((data, sequence) =>
                                    <div class={`col-xs-12 col-sm-3 col-md-3 col-lg-3 emp_${data.id} group-member tooltips`}>
                                        <div class="tooltiptext">
                                            <div class="tip_name">{data.name}</div>
                                            <div class="tip_position">{data.user_type == 1 ? data.type_name : data.position}</div>
                                        </div>
                                        <div class="details-box mb20">
                                            <div class="img-box">
                                                <img src={data.attachment}/>
                                                {this.props.hr_permission == 'yes' && !this.props.fromTroop ?
                                                <div class="boxing-close" title = "Remove Employee" data-toggle="modal" data-target="#deleteEmployee" onClick={() => this.props.parent.showRemoveEmployeeModal(this.props.group_data.id,this.props.group_data.name,data.name,0,data.id)} >
                                                    <i class="fal fa-times" ></i>
                                                </div>
                                                :''}
                                            </div>
                                            <div class="box-item">
                                                <a href={data.user_type == 1 ? "/viewGroups/"+ data.email:"/viewEmployee/"+ data.id} class="name">{data.name && data.name.length > 20 ? data.name.substring(0,20)+"...":data.name}</a>
                                                <div class="designation">
                                                    {data.user_type == 1 ? data.type_name :
                                                    data.position && data.position.length > 20 ? data.position.substring(0,20)+"...":data.position}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                )
                            }
                        </div>
                    </div>
                    </div>:""
                :""}
                {Object.values(this.props.group_members) .length > 0 ? 
                this.props.group_members['listener'] && this.props.group_members['listener'].length > 0 ? 
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 mt20">
                        <div class="all-box">
                            <div class="tab-title mb20">Listener</div>
                            <div class="row">
                            {
                                this.props.group_members['listener'].map((data, sequence) =>
                                    <div class={`col-xs-12 col-sm-3 col-md-3 col-lg-3 emp_${data.id} group-member tooltips`}>
                                        <div class="tooltiptext">
                                            <div class="tip_name">{data.name}</div>
                                            <div class="tip_position">{data.position}</div>
                                        </div>
                                        <div class="details-box mb20">
                                            <div class="img-box">
                                                <img src={data.attachment}/>
                                                {this.props.hr_permission == 'yes' && !this.props.fromTroop ?
                                                <div class="boxing-close" title = "Remove Employee" data-toggle="modal" data-target="#deleteEmployee" onClick={() => this.props.parent.showRemoveEmployeeModal(this.props.group_data.id,this.props.group_data.name,data.name,0,data.id)} >
                                                    <i class="fal fa-times" ></i>
                                                </div>
                                                :''}
                                            </div>
                                            <div class="box-item">
                                                <a href={"/viewEmployee/"+ data.id} class="name">{data.name && data.name.length > 20 ? data.name.substring(0,20)+"...":data.name}</a>
                                                <div class="designation">{data.position && data.position.length > 20 ? data.position.substring(0,20)+"...":data.position}</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            </div>
                        </div>
                    </div>:""
                : "" }
                </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/hrAdmin/DeptMembers.js